import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { API_CONFIG } from '../config/api';
import LoadingOverlay from '../components/LoadingOverlay';

const AdminPanel = ({ roles, onRoleCreate }) => {
  const [newRole, setNewRole] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const createRole = async () => {
    if (!newRole.trim()) {
      alert('Please enter a role name');
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${API_CONFIG.RESUME_API}/create-folder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ folder_name: newRole })
      });

      if (response.ok) {
        alert(`Role "${newRole}" created successfully!`);
        setNewRole('');
        await onRoleCreate();
      } else {
        alert('Failed to create role');
      }
    } catch (error) {
      console.error('Error creating role:', error);
      alert('Failed to create role. Please check if backend is running.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex-1 bg-gray-50 p-4 sm:p-6">
      <LoadingOverlay isLoading={isLoading} />
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-xl p-4 sm:p-6 md:p-8 shadow-sm border border-gray-200">
          <h2 className="text-xl sm:text-2xl font-semibold mb-2 text-gray-900">Welcome to the Admin Panel</h2>
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">Create new roles for resume management</p>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Role Name</label>
              <input
                type="text"
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && createRole()}
                placeholder="Enter role name (e.g., Software Engineer)"
                className="w-full bg-white border border-gray-300 rounded-lg p-2.5 sm:p-3 text-sm sm:text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              />
            </div>

            <button
              onClick={createRole}
              disabled={isLoading}
              className="w-full bg-orange-600 hover:bg-orange-700 disabled:bg-gray-400 text-white font-semibold py-2.5 sm:py-3 rounded-lg transition-colors shadow-sm flex items-center justify-center gap-2 text-sm sm:text-base"
            >
              <Plus size={18} className="sm:w-5 sm:h-5" />
              {isLoading ? 'Creating...' : 'Add Role'}
            </button>
          </div>

          {roles.length > 0 && (
            <div className="mt-6 sm:mt-8">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3">Existing Roles ({roles.length})</h3>
              <div className="space-y-2 max-h-48 sm:max-h-64 overflow-y-auto">
                {roles.map(role => (
                  <div key={role} className="bg-gray-50 p-2.5 sm:p-3 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors">
                    <span className="text-sm sm:text-base text-gray-700 font-medium">{role.slice(0, -1)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;